module.exports = __webpack_public_path__ + "media/images/talent/case03-badge-eef1bb6c502f807772eb70917f9440c0.png";